// claims analyst's license statuses
export const LICENSE_ACTIVE = 'active';
export const LICENSE_EXPIRING = 'expiring';
export const LICENSE_EXPIRED = 'expired';
